import React from "react";
import { Document, Page, View, Text, StyleSheet } from "@react-pdf/renderer"
import Title from "./Title"
import Header from "./Header"
import MeterView from "./MeterView"

const MultiReportDoc = ({ commitment, operations, author, startingDate, endingDate }) => {

  return (
    <Document>
      <Page size="A4" style={styles.body}>
        <View>
          <Header />
          <Title
            author={author}
            endingDate={endingDate}
            startingDate={startingDate}
            commitment={commitment}
          />
          {/** Filter out draft operation reports */}
          {operations.filter(op => op.status !== "draft").map(operation => (
            <View style={{ marginBottom: 40 }}>
              <Text style={styles.headerWithBorder}>
                {operation.operationTitle_fi_FI}
              </Text>
              <Text style={styles.h3}>
                Toimenpiteen mittarit
              </Text>
              {operation
                &&
                operation.reportMeters
                &&
                operation.reportMeters.map(meter =>
                <MeterView
                  key={meter.meterId}
                  meter={meter}
                />
              )}
              <View style={{ marginTop: 10 }}>
                {operation.progress === "NotRelevant" && <Text style={styles.text}>Toimenpide ei ole enää ajankohtainen</Text>}
                {operation.progress === "NoProgress" && <Text style={styles.text}>Toimenpiteen toteutus ei etene odotetusti</Text>}
                {operation.progress === "NotAsFast" && <Text style={styles.text}>Toimenpiteen toteutus etenee odotettua hitaammin</Text>}
                {operation.progress === "AsPlanned" && <Text style={styles.text}>Toimenpiteen toteutus etenee odotetusti</Text>}
                {operation.progress === "Faster" && <Text style={styles.text}>Toimenpiteen toteutus etenee odotettua nopeammin</Text>}
                {operation.progress === "CompletelyAchieved" && <Text style={styles.text}>Toimenpide on kokonaan toteutunut</Text>}
              </View>
              <View style={{ marginTop: 10 }}>
                <Text style={styles.text}>{operation.reportText_fi_FI}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default MultiReportDoc

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  headerWithBorder: {
    fontSize: 20,
    paddingBottom: 10,
    borderBottom: '1px solid grey',
    marginBottom: 10,
  },
  h3: {
    fontSize: 12,
  },
  text: {
    fontSize: 10,
  },
})



// WEBPACK FOOTER //
// ./src/components/printable/ReportsToPDF.jsx